
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

const AdminSearchBar = () => {
  return (
    <div className="relative max-w-md w-full">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Search..."
        className="pl-10"
      />
    </div>
  );
};

export default AdminSearchBar;
